export default {
  OS: "pwa",
  isPwa: true,
};
